import { makeAutoObservable } from 'mobx'
import type { IAlertProps } from 'shared/ui/Alert/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { BillingPath } from 'entities/ExportRouters'

type ITrialBroadcastLimitAlertStoreConfig = {
  onCloseModal?: () => void
}

export class TrialBroadcastLimitAlertStore {
  constructor(
    private _entities: IEntitiesStore,
    private _config?: ITrialBroadcastLimitAlertStoreConfig
  ) {
    makeAutoObservable(this)
  }

  get trialSubscription() {
    return this._entities.subscriptionStore.trialSubscriptionStore
  }

  get loading() {
    return this.trialSubscription.loading
  }

  init = async () => {
    if (!this._entities.subscriptionStore.isTrial) return

    await this.trialSubscription.init()
  }

  get isCompleted() {
    return this.trialSubscription.isStatusCompleted
  }

  get configAlert(): IAlertProps {
    if (this.isAdminOrOwnerRole) {
      return {
        item: {
          type: 'infoBlue',
          title: 'Your trial is limited to 25 contacts.',
          desc: this.isCompleted
            ? 'To remove the limits, please upgrade.'
            : 'To remove the limits, get approved and upgrade.',
        },
        rightActions: [
          {
            type: 'primary',
            variant: 'navLink',
            text: this.isCompleted ? 'Upgrade' : 'Get approved',
            appType: this._entities.featureFlagsStore.billing_upgrade_v2 ? 'react' : 'vue',
            link: this.isCompleted
              ? `/${BillingPath.upgrade}`
              : '/settings/organization/compliance',
            onClick: this._config?.onCloseModal,
          },
        ],
      }
    }

    return {
      item: {
        type: 'infoBlue',
        title: 'Your trial is limited to 25 contacts.',
        desc: this.isCompleted
          ? 'To remove the limits, please ask one of your admins to upgrade.'
          : 'To remove the limits, please ask one of your admins to get approved and upgrade.',
      },
    }
  }

  get isAdminOrOwnerRole() {
    return this._entities.usersStore.user?.isAdminOrOwnerRole
  }

  get hide() {
    if (this.loading) return true

    return !this._entities.subscriptionStore.isTrial
  }
}
